
import { createThreeAnimationBridge } from 'scripts/animations/animationBridge';

export {
    createProgressTimeline,
    hookOnProgress,
} from 'scripts/animations/animationBridge';

export const JoinUsThreeAnimationBridge = createThreeAnimationBridge();
